/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagonal size`)
};

const es_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño diagonal`)
};

const de_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagonale`)
};

const nl_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagonale grootte`)
};

const fr_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille diagonale`)
};

const it_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione diagonale`)
};

const pt_br2_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho diagonal`)
};

const pt_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho diagonal`)
};

const ja_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対角サイズ`)
};

const zh_ppi_diagonal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对角线尺寸`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_diagonal = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_diagonal(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_diagonal", locale)
	if (locale === "en") return en_ppi_diagonal(inputs)
	if (locale === "es") return es_ppi_diagonal(inputs)
	if (locale === "de") return de_ppi_diagonal(inputs)
	if (locale === "nl") return nl_ppi_diagonal(inputs)
	if (locale === "fr") return fr_ppi_diagonal(inputs)
	if (locale === "it") return it_ppi_diagonal(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_diagonal(inputs)
	if (locale === "pt") return pt_ppi_diagonal(inputs)
	if (locale === "ja") return ja_ppi_diagonal(inputs)
	return zh_ppi_diagonal(inputs)
};